// assets
import { IconDashboard } from "@tabler/icons";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ArticleIcon from "@mui/icons-material/Article";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SchoolIcon from "@mui/icons-material/School";

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: "dashboard",
  type: "group",
  children: [
    {
      id: "default",
      title: "Dashboard",
      type: "item",
      url: "/dashboard",
      icon: DashboardRoundedIcon,
      color: "#5e35b1", // Deep Purple
      breadcrumbs: false,
    },
    {
      id: "admissions",
      title: "Admission",
      type: "collapse",
      icon: HowToRegIcon,
      color: "#00bcd4", // Cyan
      children: [
        {
          id: "All Batches",
          title: "All Batches",
          type: "item",
          url: "/dashboard/batch/allBatches",
          breadcrumbs: false,
        },

        {
          id: "Verify Forms",
          title: "Verify Forms",
          type: "item",
          url: "/dashboard/verifyStudent/unverifiedStudents",
          breadcrumbs: false,
        },
        {
          id: "Entrance Exam",
          title: "Entrance Exam",
          type: "item",
          url: "/dashboard/entranceExam/allExams",
          breadcrumbs: false,
        },
      ],
    },
    {
      id: "studentManagement",
      title: "Student Management",
      type: "collapse",
      icon: PeopleAltIcon,
      color: "#4caf50", // Green
      children: [
        {
          id: "profileManagement",
          title: "Profile Management",
          type: "item",
          url: "/dashboard/studentProfileManagement",
          breadcrumbs: false,
        },
        {
          id: "leaves",
          title: "Leaves",
          type: "item",
          url: "/dashboard/leaveManagement/manageLeave",
          breadcrumbs: true,
        },
        {
          id: "attendance",
          title: "Attendance",
          type: "item",
          url: "/dashboard/Attendance",
          breadcrumbs: true,
        },
        {
          id: "discipline",
          title: "Discipline",
          type: "item",
          url: "/dashboard/disciplinaryAction/allDisciplinaryAction",
          breadcrumbs: true,
        },
        {
          id: "studentFile",
          title: "Student File",
          type: "item",
          url: "/dashboard/studentFile/searchStudentFile",
          breadcrumbs: true,
        },
        {
          id: "cancelAdmission",
          title: "Cancel Admission",
          type: "item",
          url: "/dashboard/cancelAdmission/allCancelAdmissionRequest",
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "academics",
      title: "Academics",
      type: "collapse",
      icon: MenuBookIcon,
      color: "#ff9800", // Orange
      children: [
        {
          id: "lectures",
          title: "Lectures",
          type: "item",
          url: "/dashboard/LectureArrangement/allLectures",
          breadcrumbs: true,
        },
        {
          id: "exams",
          title: "Exams",
          type: "collapse",
          breadcrumbs: false,
          children: [
            {
              id: "Mains Exam",
              title: "Descriptive",
              type: "item",
              url: "/dashboard/mainExam/allExams",
              breadcrumbs: false,
            },
            {
              id: "Regular Exam",
              title: "MCQ",
              type: "item",
              url: "/dashboard/regularExam/allExams",
              breadcrumbs: false,
            },
          ],
        },
        {
          id: "questionBank",
          title: "Question Bank",
          type: "collapse",
          breadcrumbs: false,
          children: [
            {
              id: "descriptiveQuestions",
              title: "Descriptive",
              type: "item",
              url: "/dashboard/mainsquestionBank/createQuestion",
              breadcrumbs: false,
            },
            {
              id: "mcqQuestions",
              title: "MCQ",
              type: "item",
              url: "/dashboard/questionBank/createQuestion",
              breadcrumbs: false,
            }
          ]
        },
        {
          id: "readingReports",
          title: "Reading Reports",
          type: "item",
          url: "/dashboard/readingReport/allReadingUpdates",
          breadcrumbs: false,
        },
        {
          id: "studentPerformance",
          title: "Student Performance",
          type: "item",
          url: "/dashboard/studentPerformence/myPerformence",
          breadcrumbs: false,
        },
      ],
    },
    {
      id: "libraryManagement",
      title: "Library Management",
      type: "collapse",
      icon: LocalLibraryIcon,
      color: "#f44336", // Red
      children: [
        {
          id: "libraryDashboard",
          title: "Library Dashboard",
          type: "item",
          url: "/dashboard/libraryManagement/allBooks",
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "officeManagement",
      title: "Office Management",
      type: "collapse",
      icon: BusinessCenterIcon,
      color: "#e91e63", // Pink
      children: [
        {
          id: "staffLeave",
          title: "Staff Leave",
          type: "item",
          url: "/dashboard/staffLeaveManagement/manageLeaveRequest",
          breadcrumbs: true,
        },
        {
          id: "createAsset",
          title: "Create Asset",
          type: "item",
          url: "/dashboard/officeManagement/createAsset",
          breadcrumbs: true,
        },
        {
          id: "createAcademicParameters",
          title: "Academic Parameters",
          type: "item",
          url: "/dashboard/admintools/academicParameters",
          breadcrumbs: true,
        },
        {
          id: "agrinis",
          title: "Agrinis",
          type: "item",
          url: "/dashboard/agrinisData/getAllAgrinisData",
          breadcrumbs: true,
        },
        {
          id: "massCommunication",
          title: "Mass Communication",
          type: "item",
          url: "/dashboard/MassCommunication/AllNotifications",
          breadcrumbs: true,
        },
        {
          id: "grievanceManagement",
          title: "Grievance Management",
          type: "item",
          url: "/dashboard/grievanceManagementAdmin/allGrievanceRequest",
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "competitiveExamData",
      title: "Competitive Exam Data",
      type: "collapse",
      icon: SchoolIcon,
      color: "#009688", // Teal
      children: [
        {
          id: "processResults",
          title: "Process Result",
          type: "item",
          url: "/dashboard/regularExam/generateResult",
          breadcrumbs: true,
        },
        {
          id: "successfulStudents",
          title: "Successful Students",
          type: "item",
          url: "/dashboard/successfullData/getAllSuccessfullData",
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "adminTools",
      title: "Admin Tools",
      type: "collapse",
      icon: AdminPanelSettingsIcon,
      color: "#3f51b5", // Indigo
      children: [
        {
          id: "users",
          title: "Users",
          type: "item",
          url: "/dashboard/admintools/users",
          breadcrumbs: true,
        },
        {
          id: "exportData",
          title: "Export Data",
          type: "item",
          url: "/dashboard/admintools/exportData",
          breadcrumbs: true,
        },
      ],
    },
  ],
};

export default dashboard;
